function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* global DGS */

import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { BrowserRouter as Router, Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { WDHComponent, onResize } from "../../../../../wdh-foundation/wdh";
import FilterView from "./views/filter-view";
import ListView from "./views/list-view";
import ListItemView from "./views/list-item-view";
import ItemDetailView from "./views/item-detail-view";
import VideoGalleryItemView from "./views/video-gallery/video-gallery-item-view.jsx";
import VideoGalleryItemDetailView from "./views/video-gallery/video-gallery-item-detail-view.jsx";
import DefaultPropTypes from "./utils/prop-types";
import ContentType from "./model/content-type";
import Filter from "./model/filter";
import FilterManager from "./utils/filter-manager";
import EmptyResultView from "./views/empty-result-view";
import Search from "./views/search/search";
import Loader from "../../../js/project/loader-react";

/**
 * @memberOf module:wdh-resource-center
 */
var WDHResourceCenter = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHResourceCenter() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "resource-center";
    _classCallCheck(this, WDHResourceCenter);
    _this = _callSuper(this, WDHResourceCenter, [className]);
    _this.defaultSettings = {
      errorMessage: '<p>Unfortunately we didn\'t find any items matching your query.</p>\n<p>\nPlease try to reset the filters by pressing "Clear all filters" or change your current filtering\n</p>',
      itemNotFoundErrorMessage: "<p>Document not found.</p>",
      dataEndpoint: "384340B0-02BB-43D3-B0CB-D6376EFB12C0",
      maxListCount: "2",
      baseEndpoint: "/webservices/downloads.svc/downloadslist/"
    };
    _this.defaultDictionary = {
      ResourceCenter: {
        filterby: "Filter by",
        viewall: "Clear filters",
        closefilters: "Close filters",
        showresults: "Show results",
        contenttypes: "All Content Types",
        viewallitems: "View all {0} items",
        back: "Back to overview",
        download: "Download",
        file: "file",
        pdf: "PDF",
        img: "image",
        video: "video",
        embed: "Watch embedded content",
        loadmore: "Load more",
        searchTitle: "Frequently asked questions",
        searchPlaceholder: "What are you looking for?",
        searchPopularQueriesTitle: "Popular searches",
        searchScrollToTop: "Go to top"
      }
    };
    _this.filterViewClass = FilterView;
    _this.listViewClass = ListView;
    _this.listItemViewClass = ListItemView;
    _this.itemDetailViewClass = ItemDetailView;
    _this.videoGalleryItemViewClass = VideoGalleryItemView;
    _this.videoGalleryItemDetailViewClass = VideoGalleryItemDetailView;
    _this.filterMode = FilterManager.FILTER_MANAGER_MODE_INCLUSIVE;
    return _this;
  }
  _inherits(WDHResourceCenter, _WDHComponent);
  return _createClass(WDHResourceCenter, [{
    key: "init",
    value: function init(component) {
      var _this2 = this;
      var path = window.location.pathname;
      var subPathIndex = path.indexOf("/doc/");
      var basename = path.substr(0, subPathIndex > -1 ? subPathIndex : path.length);
      var settings = this.getSettingsFromComponent(component);
      var componentType = this.getComponentType(component);
      var language = $("html").attr("lang");
      ReactDOM.render(/*#__PURE__*/React.createElement(Loader, null), component.querySelector(".component-content"));
      DGS.Dictionary.getInstance().getTexts(this.defaultDictionary, function () {
        ReactDOM.render(/*#__PURE__*/React.createElement(Router, {
          basename: basename
        }, /*#__PURE__*/React.createElement(ResourceCenterWithRouter, {
          settings: settings,
          componentType: componentType,
          dictionary: _this2.defaultDictionary.ResourceCenter,
          FilterViewClass: _this2.filterViewClass,
          filterMode: _this2.filterMode,
          ListViewClass: _this2.listViewClass,
          ListItemViewClass: _this2.listItemViewClass,
          VideoGalleryItemViewClass: _this2.videoGalleryItemViewClass,
          VideoGalleryItemDetailViewClass: _this2.videoGalleryItemDetailViewClass,
          ItemDetailViewClass: _this2.itemDetailViewClass
        })), component.querySelector(".component-content"));
      }, language);
    }
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      try {
        var settings = JSON.parse(component.querySelector('script[type="application/json"]').innerHTML);
        return Object.assign(this.defaultSettings, settings);
      } catch (e) {
        return this.defaultSettings;
      }
    }
  }, {
    key: "getComponentType",
    value: function getComponentType(component) {
      var types = ["resource-center-faq", "resource-center-video-gallery", "resource-center-download-center", "resource-center-search-and-faq"];
      var componentType = types.filter(function (type) {
        return component.classList.contains(type);
      });
      return componentType ? componentType[0].replace("resource-center-", "") : null;
    }
  }]);
}(WDHComponent);
var ResourceCenter = /*#__PURE__*/function (_React$Component) {
  function ResourceCenter(props) {
    var _this3;
    _classCallCheck(this, ResourceCenter);
    _this3 = _callSuper(this, ResourceCenter, [props]);
    _this3.filterManager = new FilterManager();
    _this3.filterManager.filterMode = _this3.props.filterMode;
    _this3.rawData = ResourceCenter.getEmptyData();
    _this3.state = {
      contentTypes: _this3.rawData.contentTypes,
      filters: _this3.rawData.filters,
      isDesktop: ResourceCenter.isDesktop(),
      filtersVisible: false,
      loading: false,
      selectedItemId: null,
      showFilters: window.location.search.indexOf("show-filters") > -1
    };
    _this3.onShowItemDetails = _this3.onShowItemDetails.bind(_this3);
    _this3.onHideItemDetails = _this3.onHideItemDetails.bind(_this3);
    _this3.handleFilterElementChange = _this3.handleFilterElementChange.bind(_this3);
    _this3.handleToggleShowFilters = _this3.handleToggleShowFilters.bind(_this3);
    _this3.handleFilterClearAll = _this3.handleFilterClearAll.bind(_this3);
    _this3.parseFiltersFromQueryParams = _this3.parseFiltersFromQueryParams.bind(_this3);
    _this3.onHandleDetailViewByKeyboard = _this3.onHandleDetailViewByKeyboard.bind(_this3);
    _this3.updateStateWithItemByContentType = _this3.updateStateWithItemByContentType.bind(_this3);
    return _this3;
  }
  _inherits(ResourceCenter, _React$Component);
  return _createClass(ResourceCenter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      this.getItemsFromEndpoint().then(function () {
        _this4.filterManager.categoryMappings = _this4.rawData.filters;
        _this4.parseFiltersFromQueryParams();
        _this4.updateStateWithItems();
      });
      var selectedItemId = this.props.location.pathname.split("/")[2];
      if (selectedItemId) {
        this.setState({
          selectedItemId: selectedItemId
        });
      }
      onResize(function () {
        _this4.setState({
          isDesktop: ResourceCenter.isDesktop()
        });
      });
    }

    /**
     * Sets the passed Item as the selected item.
     * @param {Event} event
     * @param {Item} selectedItem
     */
  }, {
    key: "onShowItemDetails",
    value: function onShowItemDetails(event, selectedItem) {
      event.preventDefault();
      if (selectedItem.shouldDownload()) {
        window.open(selectedItem.url, "_blank");
      } else {
        if (this.state.selectedItemId === selectedItem.id) {
          this.onHideItemDetails(event);
        } else {
          this.props.history.push({
            pathname: "/doc/".concat(selectedItem.id),
            search: this.props.location.search
          });
          this.setState({
            selectedItemId: selectedItem.id
          });
          $(".lightbox-close").focus();
          $(window).on("keydown", this.onHandleDetailViewByKeyboard);
        }
      }
    }
  }, {
    key: "onHideItemDetails",
    value: function onHideItemDetails(event) {
      event.preventDefault();
      this.props.history.push({
        pathname: "/",
        search: this.props.location.search
      });
      this.setState({
        selectedItemId: null
      });
      $(window).off("keydown", this.onHandleDetailViewByKeyboard);
    }
  }, {
    key: "onHandleDetailViewByKeyboard",
    value: function onHandleDetailViewByKeyboard(e) {
      if (e.keyCode === 9) {
        if (document.activeElement === $(".lightbox-download")[0]) {
          $(".lightbox-close").focus();
          e.preventDefault();
        }
      }
      if (e.keyCode === 27) {
        this.onHideItemDetails(e);
      }
    }
  }, {
    key: "getItemsFromEndpoint",
    value: function getItemsFromEndpoint() {
      var _this5 = this;
      this.setState({
        loading: true
      });
      var language = $("html").attr("lang");
      var endPoint = "".concat(this.props.settings.baseEndpoint, "/").concat(this.props.settings.dataEndpoint, "/refresh/").concat(language);
      return axios.post(endPoint, {}).then(function (response) {
        _this5.rawData = ResourceCenter.isValidResponse(response) ? {
          contentTypes: ContentType.fromEndpoint(response.data.contentTypes),
          filters: Filter.fromEndpoint(response.data.filters)
        } : ResourceCenter.getEmptyData();
      }).finally(function () {
        return _this5.setState({
          loading: false
        });
      });
    }

    /**
     * Parses and validates filters set in query params
     */
  }, {
    key: "parseFiltersFromQueryParams",
    value: function parseFiltersFromQueryParams() {
      // Gets everything from 'filters=foo,bar&otherparam=xxx' up until '&' excluding 'filters='
      // result: 'foo,bar'
      var queryValue = this.props.location.search.match(/(?:\?filters=)([^&]+)/);
      // convert it to an array
      var filtersFromQueryParams = queryValue && queryValue[1] && queryValue[1].split(",");
      var filters = [];
      if (filtersFromQueryParams) {
        filters = filtersFromQueryParams;
      } else if (this.props.settings.filtersPredefined) {
        filters = JSON.parse(this.props.settings.filtersPredefined);
      }
      // Flatten all filter ids from rawData.filters[].elements[].id into one single array
      var allFilters = this.rawData.filters.map(function (filter) {
        return filter.elements.map(function (element) {
          return element.id;
        });
      }).flatten();
      // Exclude non-valid filter ids.
      var validFilterIds = filters.reduce(function (acc, key) {
        return allFilters.indexOf(key) > -1 ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, true)) : acc;
      }, {});
      // Apply the filters in filterManager
      this.filterManager.filterIds = validFilterIds;
    }
  }, {
    key: "handleFilterClearAll",
    value: function handleFilterClearAll() {
      this.filterManager.clearFilters();
      this.updateStateWithItems();
    }
  }, {
    key: "handleFilterElementChange",
    value: function handleFilterElementChange(element) {
      // element.selected = !element.selected;
      this.filterManager.updateFilter(element);
      this.updateStateWithItems();
    }
  }, {
    key: "handleToggleShowFilters",
    value: function handleToggleShowFilters() {
      this.setState({
        filtersVisible: !this.state.filtersVisible
      });
    }
  }, {
    key: "updateStateWithItems",
    value: function updateStateWithItems() {
      var filterIds = Object.keys(this.filterManager.filterIds);
      var searchFilters = filterIds.length ? "filters=".concat(filterIds) : "";
      var search = this.state.showFilters ? "?show-filters&".concat(searchFilters) : "?".concat(searchFilters);
      this.props.history.push({
        pathname: this.props.location.pathname,
        search: search
      });
      this.setState({
        contentTypes: this.filterManager.parseContentTypes(this.rawData.contentTypes),
        filters: this.filterManager.parseFilters(this.rawData.filters)
      });
    }
  }, {
    key: "updateStateWithItemByContentType",
    value: function updateStateWithItemByContentType(contentType) {
      this.setState({
        contentTypes: contentType
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        FilterViewClass = _this$props.FilterViewClass,
        ListViewClass = _this$props.ListViewClass,
        ListItemViewClass = _this$props.ListItemViewClass,
        VideoGalleryItemViewClass = _this$props.VideoGalleryItemViewClass,
        VideoGalleryItemDetailViewClass = _this$props.VideoGalleryItemDetailViewClass,
        settings = _this$props.settings,
        dictionary = _this$props.dictionary,
        componentType = _this$props.componentType;
      var _this$state = this.state,
        isDesktop = _this$state.isDesktop,
        filters = _this$state.filters,
        contentTypes = _this$state.contentTypes,
        filtersVisible = _this$state.filtersVisible,
        loading = _this$state.loading,
        selectedItemId = _this$state.selectedItemId,
        showFilters = _this$state.showFilters;
      var allItems = this.rawData.contentTypes.map(function (type) {
        return type.items;
      }).flatten();
      var selectedItem = allItems.find(function (item) {
        return item.id === selectedItemId;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "outer-container ".concat(isDesktop ? "desktop-section" : "mobile-section")
      }, !loading && /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, componentType === "search-and-faq" && filters.length && /*#__PURE__*/React.createElement(Search, {
        filters: filters,
        contentTypes: contentTypes,
        rawContentTypes: this.rawData.contentTypes,
        onChange: this.handleFilterElementChange,
        onClearAll: this.handleFilterClearAll,
        updateItemsByContentType: this.updateStateWithItemByContentType,
        title: dictionary.searchTitle,
        placeholder: dictionary.searchPlaceholder,
        popularQueriesTitle: dictionary.searchPopularQueriesTitle,
        scrollToTopLabel: dictionary.searchScrollToTop,
        isDesktop: isDesktop
      }), (componentType !== "search-and-faq" || showFilters) && /*#__PURE__*/React.createElement(FilterViewClass, {
        settings: settings,
        dictionary: dictionary,
        isDesktop: isDesktop,
        filters: filters,
        filtersVisible: filtersVisible,
        onChange: this.handleFilterElementChange,
        onClearAll: this.handleFilterClearAll,
        onToggleShowFilters: this.handleToggleShowFilters,
        filterButtonLabel: dictionary.filterby,
        clearAllButtonLabel: dictionary.viewall,
        closeFiltersButtonLabel: dictionary.closefilters
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/doc/:id"
      }), selectedItem === undefined && selectedItemId !== null && /*#__PURE__*/React.createElement(EmptyResultView, {
        errorMessage: settings.itemNotFoundErrorMessage
      }), !!contentTypes.length && /*#__PURE__*/React.createElement(ListViewClass, {
        settings: settings,
        dictionary: dictionary,
        isDesktop: isDesktop,
        contentTypes: contentTypes,
        ListItemViewClass: ListItemViewClass,
        VideoGalleryItemViewClass: VideoGalleryItemViewClass,
        VideoGalleryItemDetailViewClass: VideoGalleryItemDetailViewClass,
        onItemClick: this.onShowItemDetails,
        onClose: this.onHideItemDetails,
        selectedItem: selectedItem,
        componentType: componentType,
        allItems: allItems,
        filters: filters
      }), !contentTypes.length && /*#__PURE__*/React.createElement(EmptyResultView, {
        errorMessage: settings.errorMessage
      })), loading && /*#__PURE__*/React.createElement(Loader, null));
    }
  }], [{
    key: "getEmptyData",
    value: function getEmptyData() {
      return {
        contentTypes: [],
        filters: []
      };
    }
  }, {
    key: "isValidResponse",
    value: function isValidResponse(response) {
      return response.data && response.data.contentTypes && response.data.filters;
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia("(min-width: 768px)").matches;
    }
  }]);
}(React.Component);
ResourceCenter.propTypes = {
  settings: DefaultPropTypes.settings.isRequired,
  dictionary: DefaultPropTypes.dictionary.isRequired,
  FilterViewClass: PropTypes.func.isRequired,
  ListViewClass: PropTypes.func.isRequired,
  ListItemViewClass: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired,
  filterMode: PropTypes.string.isRequired,
  componentType: PropTypes.string.isRequired
};
ResourceCenter.defaultProps = {};
var ResourceCenterWithRouter = withRouter(ResourceCenter);
export default WDHResourceCenter;